import React from 'react';
import { Hero } from '../components/Hero';
import { Legacy } from '../components/Legacy';
import { CompetencyGrid } from '../components/CompetencyGrid';
import { StrategicMap } from '../components/StrategicMap';
import { CapabilityStatement } from '../components/CapabilityStatement';
export function Home() {
  return <>
      <Hero data-id="element-424" />
      <Legacy data-id="element-425" />
      <CompetencyGrid data-id="element-426" />
      <StrategicMap data-id="element-427" />
      <CapabilityStatement data-id="element-428" />
    </>;
}